import register from '../register';
import Clipboard from 'clipboard';

register( 'social-share-petition', () => {
  let clipboard = new Clipboard('.js-clipboard');

  clipboard.on( 'success', e => e.trigger.classList.add('success') );
});

export default undefined;
